export const XRP = () => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="16" fill="#24292E" />
    <g clipPath="url(#clip0_1_3235)">
      <path
        d="M22.6162 8.2478H25.3287L19.6838 13.837C17.6395 15.86 14.3252 15.86 12.2794 13.837L6.63232 8.2478H9.34701L13.6357 12.4936C14.2605 13.1094 15.1026 13.4547 15.98 13.4547C16.8573 13.4547 17.6994 13.1094 18.3242 12.4936L22.6162 8.2478Z"
        fill="white"
      />
      <path
        d="M9.31222 23.7896H6.5979L12.2795 18.1659C14.3237 16.1429 17.6381 16.1429 19.6838 18.1659L25.3654 23.7896H22.6529L18.3276 19.5093C17.7027 18.8935 16.8606 18.5483 15.9833 18.5483C15.106 18.5483 14.2639 18.8935 13.639 19.5093L9.31222 23.7896Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_3235">
        <rect
          width="18.7675"
          height="15.5418"
          fill="white"
          transform="translate(6.5979 8.24744)"
        />
      </clipPath>
    </defs>
  </svg>
);
